<template>
  <div class="sign-register">
    <div class="content-box" :class="{ 'disabled': preview == 1 }" id="contentBox">
      <div class="error-msg" v-if="errMsg">{{ errMsg }}</div>
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(vv, ii) in ['data1', 'data2']" :key="ii">
            <div class="res-box" v-show="swiperIndex == ii">
              <div class="res-from">
                <div
                  :class="[item.formType == 9 ? 'line' : 'res-from-li', item.className, item.value, { 'textarea': item.formType == 2 }]"
                  v-for="(item, i) in fromList[vv]"
                  :key="i"
                >
                  <div class="tip-box" v-if="stepConfig && stepConfig.topCopyWriter && i == 0">
                    <img src="@/static/images/sign/tip-icon.png" />
                    <div class="register-info">{{ stepConfig.topCopyWriter }}</div>
                  </div>
                  <!-- 分隔标题 -->
                  <span v-if="item.formType == 9">{{ item.title }}</span>
                  <div v-else-if="item.formType == 'formItemTitle'"></div>
                  <template v-else-if="item.formType == 5 || item.formType == 6">
                    <!-- <div class="res-from-box cover-box cover-box--title" v-if="item.titleCover">
                      <div class="res-from-top">
                        <div class="res-from-name"><required v-show="item.requiredIcon == 1"/>{{ item.title }}</div>
                        <div class="res-from-right">{{item.description}}</div>
                      </div>
                    </div> -->
                    <!-- 上传图片 -->
                    <upload
                      :selectData="item"
                      @result="uploadResult"
                      :disabled="item.isRead == 1"
                      ref="upload"
                    />
                  </template>
                  <template v-else>
                    <div class="res-from-box">
                      <div class="res-from-name" :style="{flex: `0 0 ${item.titleWidth || 'initial'}`}"><required v-show="item.requiredIcon == 1"/>{{ item.title }}</div>
                      <!-- 文本输入 1单行 2多行 -->
                      <div class="res-from-right" v-if="item.formType == 1 || item.formType == 2" :style="{flex: item.titleWidth?'1': 'initial'}">
                        <email :selectData="item" v-if="item.value == 'email'" :scrollHeight="scrollHeight" :disabled="item.isRead == 1"></email>
                        <input
                          v-else-if="item.formType == 1"
                          type="text"
                          v-model="item.data"
                          :disabled="item.isRead == 1"
                          :placeholder="item.content"
                          @input="inputChange(item)"
                        />
                        <van-field
                          v-else-if="item.formType == 2"
                          v-model="item.data"
                          rows="1"
                          autosize
                          type="textarea"
                          :disabled="item.isRead == 1"
                          :placeholder="item.content"
                        />
                        <bankIco :selectData="item" v-if="item.value == 'cardNo' && item.isRead != 1" @getBankInfo="inputChange(item)"></bankIco>
                      </div>
                      <!-- 下拉 7单选 10机构搜索 -->
                      <div class="res-from-right" v-else-if="item.formType == 7 || item.formType == 10" @click="openSelect(item)"  :style="{flex: item.titleWidth?'1': 'initial'}">
                        <input type="text" :value="item.dataText" readonly :placeholder="item.content" style="padding-right: 15px" />
                        <i class="iconfont icon-youjiantou"></i>
                      </div>
                      <!-- 按钮单选 -->
                      <div class="res-from-right" v-if="item.formType == 12">
                        <ul class="slelect-list">
                          <li v-for="(bean, i) in item.list" :key="i" :class="{ 'active': bean.val == item.data }" @click="item.data = bean.val">
                            {{ bean.text }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div v-if="item.value == 'permanentWork'" class="permanentWork-example">
                      <div class="permanentWork-example__title">地址示例：</div>
                      <div class="permanentWork-example__content">xx区xx路xx号xx（小区）xx（楼栋）xx室</div>
                      <div class="permanentWork-example__content">xx县xx村xx号</div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="res-box bottom-box" v-if="preview != 1">
      <!-- <div class="register-btn" @click="save">暂存</div> -->
      <div v-if="swiperIndex == 0" class="register-btn" :class="{ 'active': isWrite }" @click="swiperIndex = '1'">下一页</div>
      <div v-if="swiperIndex == 1" @click="swiperIndex = '0'" class="btn-back">上一页</div>
      <div v-if="swiperIndex == 1" class="btn-next" @click="submit">下一步</div>
    </div>

    <div class="select-layer-box" v-show="showSelectLayer">
      <div class="mask" @click.stop="showSelectLayer = false"></div>
      <div class="mainContent">
        <van-picker
          show-toolbar
          :title="selectData.title"
          :columns="selectData.list"
          default-index="0"
          value-key="text"
          @cancel="showSelectLayer = false"
          @confirm="selectSure"
          :class="{ 'null-picker': !selectData.list || selectData.list.length == 0 }"
        >
          <div slot="columns-top">
            <div class="columns-top" v-if="selectData.formType == 10">
              <input type="text" v-model.trim="keyword" placeholder="请输入关键字搜索" @input="searchOrg" />
            </div>
            <template v-if="!selectData.list || selectData.list.length == 0">
              <div class="null" v-if="keyword">
                <img class="null-img" src="@static/images/null.png" />
                <span class="null-text">未查询到{{ selectData.title }}数据</span>
              </div>
              <div class="null" v-else></div>
            </template>
          </div>
        </van-picker>
      </div>
    </div>
    <van-action-sheet
      v-model="showAction"
      :actions="[{ name: '拍照' }, { name: '从相册中选取' }]"
      cancel-text="取消"
      close-on-click-action
      @select="selectAction"
    />
    <addressErrorPopup ref="addressErrorPopup"/>
  </div>
</template>
<script>
import upload from './components/upload';
import bankIco from './components/bankIco';
import email from './components/email';
import login from './components/login.js';
import fromList from './components/ok-register.js';
import required from './components/required';
import addressErrorPopup from './components/addressErrorPopup';
import { common } from '@/api/mixins';
import city from '@/datas/city-picker.js';
import _ from 'lodash';
import notice from "@/api/notice";
//当前实例组件
export default {
  name: 'indexBox',
  mixins: [common, login],
  components: {
    bankIco,
    upload,
    email,
    required,
    addressErrorPopup
  },
  computed: {
    isWrite() {
      let isWrite = true;
      for (const key in this.fromList) {
        this.fromList[key].forEach(item => {
          if (item.value == 'cardFront' && !item.data) {
            isWrite = false;
          }
          if (item.value == 'cardBack' && !item.data) {
            isWrite = false;
          } else if (item.value == 'name' && !item.data) {
            isWrite = false;
          } else if (item.value == 'birthday' && !item.data) {
            isWrite = false;
          } else if (item.value == 'idcard' && !item.data) {
            isWrite = false;
          } else if (item.value == 'nation' && !item.data) {
            isWrite = false;
          } else if (item.value == 'sex' && !item.data) {
            isWrite = false;
          } else if (item.value == 'idStartDate' && !item.data) {
            isWrite = false;
          } else if (item.value == 'idEndDate' && !item.data) {
            isWrite = false;
          } else if (item.value == 'handIdCard' && !item.data) {
            isWrite = false;
          }
        });
      }
      return isWrite;
    }
  },
  props: ['stepConfig'],
  data() {
    return {
      fromList: [],
      selectData: {},
      formData: {},
      orgId: '',
      preview: '',
      errMsg: '',
      keyword: '',
      showSelectLayer: false,
      submiting: false,
      showfrom: false,
      scrollHeight: 0,
      swiperIndex: 0,
      showAction: false
    };
  },
  watch: {
    fromList: {
      handler(val, oldVal) {
        // 自动保存到本地
        if (this.formData.id) {
          const data = this.getResult();
          data.id = this.formData.id;
          if (typeof data.diploma == 'object') {
            data.diploma = JSON.stringify(data.diploma);
          }
          localStorage['okbaoSignForm' + data.id] = JSON.stringify(data);
        }
      },
      deep: true
    }
  },
  mounted() {
    this.orgId = this.$route.query.orgId;
    this.preview = this.$route.query.preview;
    this.checkLogin(this.preview == 1 || this.$route.query.noCheckStatus == 1).then(async () => {
      this.scrollHeight = document.getElementById('contentBox').scrollHeight;
      await this.setAllData();
      this.getInfo();
    });
  },
  methods: {
    // 获取已填信息
    getInfo() {
      if (this.preview == 1) {
        //预览
        this.getFormList();
        return;
      }
      this.$http({
        type: 'POST',
        url: '/api/userAuth/detail',
        data: {
          token: localStorage.regToken,
          orgId: this.orgId
        }
      }).then(res => {
        const data = res.data;
        const localData = localStorage['okbaoSignForm' + data.id] ? JSON.parse(localStorage['okbaoSignForm' + data.id]) : {}; //获取本地数据
        if (data.reason) {
          if (data.auditStatus == 3) {
            this.$notice.alert('您的入职信息已被驳回，原因为：' + data.reason);
          }
        }
        if (localData.id == data.id) {
          // 存在本地缓存更新数据
          Object.assign(data, localData);
        }
        this.formData = data;
        this.getFormList();
        // OK保的没有推荐人可以修改
        if (!res.data.recommenderId) {
          fromList.data2.forEach(item => {
            if (item.value == 'recommenderName') {
              item.isRead = '0';
            }
            if (item.value == 'recommenderCode') {
              item.isRead = '0';
            }
          });
        }
      });
    },
    // 获取表单数据
    getFormList() {
      for (const key in fromList) {
        fromList[key].forEach((item, i) => {
          if (
            (item.value == 'cardFront' || item.value == 'cardBack') &&
            fromList[key][i + 1] &&
            (fromList[key][i + 1].value == 'cardFront' || fromList[key][i + 1].value == 'cardBack')
          ) {
            item.className = 'small';
            fromList[key][i + 1].className = 'small hideName';
          }
          if (
            (item.value == 'photo' || item.value == 'photoExample') &&
            fromList[key][i + 1] &&
            (fromList[key][i + 1].value == 'photo' || fromList[key][i + 1].value == 'photoExample')
          ) {
            item.className = 'small';
            fromList[key][i + 1].className = 'small hideName';
          }
          if (this.formData.auditStatus == 3 && item.value == 'cardFront') {
            //驳回不可编辑
            item.isRead = '1';
          }

          if (this.formData[item.value]) {
            item.data = this.formData[item.value];
          } else {
            item.data = '';
          }
          if (item.value == 'idcard' && this.formData.idcard1) {
            item.data = this.formData.idcard1;
          } else if (item.value == 'organizationId') {
            if (this.formData.orgName) {
              item.dataText = this.formData.orgName;
            } else {
              // item.dataText = "梧桐树湖北分公司";
              // item.data = this.$config.env == 1 ? '1613425927997165569' : '1701420194818879490';
            }
          } else if (item.value == 'province,city' || item.value == 'bankProvince,bankCity') {
            const keys = item.value.split(',');
            let province = this.formData[keys[0]];
            let city = this.formData[keys[1]];
            if (province == city) {
              item.data = province;
              item.dataText = province;
            } else {
              item.data = province + city;
              item.dataText = province + city;
            }
            item.dataArr = [province, city];
          }
          item.list = [];
          this.setList(item);
        });
      }
      this.fromList = fromList;
    },
    // 设置字典数据
    setList(item) {
      if (this.preview == 1) {
        //预览不调用
        return;
      }
      if (item.value == 'province,city' || item.value == 'bankProvince,bankCity') {
        this.$set(item, 'list', city);
      } else if (item.value == 'rankId') {
        //职级
        this.$http({
          type: 'POST',
          url: '/api/userAuth/queryValidRank',
          data: {
            token: localStorage.regToken,
            orgId: this.orgId
          }
        }).then(res => {
          const list = res.data.map(bean => {
            if (bean.id == item.data) {
              this.$set(item, 'dataText', bean.name);
            }
            return {
              val: bean.id,
              text: bean.name
            };
          });
          this.$set(item, 'list', list);
        });
      } else if (item.optionsVlaue) {
        let list = [];
        const data = this.all[item.optionsVlaue];
        for (const key in data) {
          if (Object.hasOwnProperty.call(data, key)) {
            list.push({
              val: key,
              text: data[key]
            });
          }
        }
        this.$set(item, 'list', list);
        if (item.data) {
          this.$set(item, 'dataText', data[item.data]);
        }
      }
    },
    // 打开选择面板
    openSelect(item) {
      console.log(item);
      this.selectData = item;
      this.showSelectLayer = true;
      this.keyword = '';
      if (item.value == 'organizationId') {
        this.searchOrg();
      }
    },
    // 下拉单选
    selectSure(e) {
      if (this.selectData.formType == 10 && this.selectData.list.length == 0) {
        return;
      }
      if (this.selectData.value == 'province,city' || this.selectData.value == 'bankProvince,bankCity') {
        let text = e.join('');
        if (e[0] == e[1]) {
          text = e[0];
        }
        this.$set(this.selectData, 'data', text);
        this.$set(this.selectData, 'dataText', text);
        this.$set(this.selectData, 'dataArr', e);
      } else {
        this.$set(this.selectData, 'data', e.val);
        this.$set(this.selectData, 'dataText', e.text);
      }

      this.showSelectLayer = false;
    },
    // 搜索机构
    searchOrg: _.debounce(function () {
      this.searchOrgAjax();
    }, 300),
    // 搜索机构ajax
    searchOrgAjax() {
      this.$http({
        url: '/api/userAuth/queryOrgList',
        data: {
          token: localStorage.regToken,
          orgName: this.keyword
        }
      }).then(res => {
        if (res.data) {
          const out = [];
          const arr = ['总部', '湖北', '广东', '深圳', '北京', '江西', '河北', '陕西', '江苏', '四川', '青岛'];
          const list = res.data.map(item => {
            return {
              val: item.id,
              text: item.fullName
            };
          });
          arr.forEach(name => {
            list.forEach(item => {
              if (name == '总部' && item.text == '梧桐树保险经纪有限公司') {
                // 总部特殊处理
                out.push(item);
              } else if (item.text.includes(name)) {
                out.push(item);
              }
            });
          });
          this.selectData.list = out;
        }
      });
    },
    // 上传回调
    uploadResult(data, selectData) {
      console.log('selectData---', selectData);
      console.log('this.fromList---', this.fromList);
      for (const key in this.fromList) {
        this.fromList[key].forEach(item => {
          if (selectData.value == 'cardFront') {
            if (item.value == 'name') {
              item.data = data.name || '';
            } else if (item.value == 'birthday') {
              if (data.birthday) {
                item.data = data.birthday.substr(0, 4) + '-' + data.birthday.substr(4, 2) + '-' + data.birthday.substr(6, 2);
              } else {
                item.data = '';
              }
            } else if (item.value == 'idcard') {
              item.data = data.idcard || '';
            } else if (item.value == 'nation') {
              const nation = data.nation || '';
              item.data = nation.includes('族') ? nation : nation + '族';
            } else if (item.value == 'sex') {
              item.data = data.sex || '';
            }
          } else if (selectData.value == 'cardBack') {
            if (item.value == 'idStartDate') {
              if (data.startDate) {
                item.data = data.startDate.substr(0, 4) + '-' + data.startDate.substr(4, 2) + '-' + data.startDate.substr(6, 2);
              } else {
                item.data = '';
              }
            } else if (item.value == 'idEndDate') {
              if (data.endDate == '长期') {
                item.data = data.endDate;
              } else if (data.endDate) {
                item.data = data.endDate.substr(0, 4) + '-' + data.endDate.substr(4, 2) + '-' + data.endDate.substr(6, 2);
              } else {
                item.data = '';
              }
            }
          }
        });
      }
    },
    checkOrgArea(result) {
      //常驻地区和入职机构所在地区保持一致。深圳需对应到深圳市，其他地区对应到省份即可。总部对应到湖北
      if ((result.orgName == '梧桐树保险经纪有限公司' || result.orgName.includes('湖北')) && !result.city.includes('湖北')) {
        //总部
        this.$notice.msg('常住地区和入职机构所在地区不一致，请修改');
        return false;
      } else if (result.orgName.includes('深圳') && !result.city.includes('深圳')) {
        this.$notice.msg('常住地区和入职机构所在地区不一致，请修改');
        return false;
      } else if (
        !result.orgName.includes(result.province.slice(0, result.province.length - 1)) &&
        !result.orgName.includes(result.city.slice(0, result.city.length - 1))
      ) {
        this.$notice.msg('常住地区和入职机构所在地区不一致，请修改');
        return false;
      }
      return true
    },
    // 提交
    submit() {
      if (this.submiting) return;
      this.submiting = true;
      if (!this.checkFrom()) {
        this.submiting = false;
        return;
      }
      let result = this.getResult();
      result.token = localStorage.regToken;
      // console.log('result', result);
      // if(!this.checkOrgArea(result)){
      //   this.submiting = false;
      //   return;
      // }
      this.$http({
        url: '/api/userAuth/saveInfo',
        data: result,
        hideAlert: true,
      })
        .then(res => {
          if(res.httpCode == 200001 && this.$tools.isOKbao(this.stepConfig.merchantNo)) {
            this.submiting = false;
            // 弹窗提醒
            this.$refs.addressErrorPopup.showPopup()
            return
          }
          if(res.httpCode != 1) {
            this.submiting = false;
            this.$notice.alert(res.msg);
            return
          }
          this.$notice.msg('登记信息提交成功！');
          localStorage['okbaoSignForm' + this.formData.id] = '';
          setTimeout(() => {
            const status = Number(res.data.status);
            this.jump(status);
          }, 1000);
        })
        .catch(err => {
          this.submiting = false;
        });
    },
    save() {
      let result = this.getResult();
      result.token = localStorage.regToken;
      this.$http({
        url: '/api/userAuth/stag/saveInfo',
        data: result
      }).then(res => {
        // this.$notice.msg("保存成功！");
      });
    },
    // 检查表单是否填写完全
    checkFrom() {
      var hasFalse = false;
      const tipArr = [];
      for (const key in this.fromList) {
        this.fromList[key].find(item => {
          if (item.formType == 9) {
            //分隔栏不处理
            return false;
          }
          let dataType = typeof item.data;
          if (dataType == 'number') {
            item.data = item.data.toString();
          }
          if ((!item.data || item.data.length == 0) && item.isRequired == 1) {
            this.showError(item, true);
            hasFalse = true;
            tipArr.push(item);
            return true;
          }
          if (item.data && !item.data.includes('*') && item.checks && !new RegExp(item.checks.toString()).test(item.data)) {
            this.showError(item, false);
            hasFalse = true;
            tipArr.push(item);
            return true;
          }
          return false;
        });
      }
      if (tipArr.length == 1) {
        this.swiperIndex = '1';
      }
      return !hasFalse;
    },
    showError(item, isNUll) {
      if (isNUll) {
        let text = '填写';
        if (item.formType == 5 || item.formType == 6) {
          text = '上传';
        } else if ([7, 10, 12].includes(item.formType * 1)) {
          text = '选择';
        }
        this.$notice.msg(`${item.title}尚未${text}`);
      } else {
        if (item.value == 'remarkExplain') {
          this.$notice.msg(`${item.title}不能超过100字`);
        } else if (item.value == 'weight' || item.value == 'height') {
          this.$notice.msg(`${item.title}请输入正整数`);
        } else if (item.value == 'permanentWork') {
          this.$notice.msg(`${item.title}不得少于8个字，且最后一个字只能为室或者号`);
        } else {
          this.$notice.msg(`${item.title}格式有误`);
        }
      }
    },
    getResult() {
      let result = {};
      for (const key in this.fromList) {
        this.fromList[key].forEach(item => {
          if (item.value == 'province,city') {
            result.province = item.dataArr[0];
            result.city = item.dataArr[1];
          } else if (item.value == 'bankProvince,bankCity') {
            result.bankProvince = item.dataArr[0];
            result.bankCity = item.dataArr[1];
          } else if (item.data) {
            result[item.value] = item.data;
          }
          if (item.value == 'organizationId') {
            result.orgName = item.dataText;
          }
        });
      }
      return result;
    },
    // 银行卡识别
    inputChange(item) {
      if (item.value == 'cardNo') {
        if (item.data && item.data.includes(' ')) {
          this.$set(item, 'data', item.data.replace(/ /g, ''));
        }
        if (!item.data || !this.$regulars.isBankCard(item.data)) {
          return;
        }
        this.$http({
          url: '/api/userAuth/queryBankByCardNo',
          data: {
            token: localStorage.regToken,
            cardNo: item.data
          }
        }).then(res => {
          this.setBankName(res.data);
        });
      }
    },
    setBankName(name) {
      if (!name) {
        this.$set(item, 'data', '');
        this.$set(item, 'dataText', '');
        return;
      }
      for (const key in this.fromList) {
        this.fromList[key].find(item => {
          if (item.value == 'bank') {
            const info = item.list.find(item => item.text.includes(name));
            if (info) {
              this.$set(item, 'data', info.val);
              this.$set(item, 'dataText', info.text);
            }
            return true;
          }
        });
      }
    },
    selectAction(data) {
      this.$refs.upload.map(item => {
        if (item.selectData.value == 'photo') {
          item.selectAction(data);
        }
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.path == '/apps/sign/takePhoto') {
        vm.activeIndex = '1';
      }
    });
  }
};
</script>
<style lang="scss" scoped>
@import './register.scss';
.tip-box {
  width: 690px;
  background: #fefced;
  border-radius: 8px 8px 8px 8px;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  margin-bottom: 30px;
  .register-info {
    font-size: 24px;
    color: #cb9244;
  }
  img {
    width: 24px;
    flex-shrink: 0;
    margin-right: 10px;
    margin-top: 0.06rem;
  }
}
.sign-register {
  .swiper-pagination {
    position: fixed;
    bottom: 140px;
    /deep/.swiper-pagination-bullet {
      background: #b2b2b2;
      width: 16px;
      height: 16px;
      opacity: 1;
    }
    /deep/.swiper-pagination-bullet-active {
      background: #ffffff;
      border: 1px solid #bfbfbf;
    }
  }
  .register-btn {
    flex: 1;
    font-size: 32px;
    width: 690px;
    height: 88px;
    border-radius: 44px;
    background-color: #fedcb2;
    border: 1px solid #fedcb2;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .btn-back {
    width: 330px;
    height: 88px;
    border-radius: 44px;
    border: 1px solid #fd8b01;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    color: #fd8b01;
  }
  .btn-next {
    width: 330px;
    height: 88px;
    background: #ff8b00;
    border-radius: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    color: #ffffff;
  }
  .active {
    background-color: #ff8b00;
    border: 1px solid #ff8b00;
    pointer-events: unset;
  }
  .hideName {
    /deep/.res-from-content {
      justify-content: flex-end;
      .van-popup--bottom {
        right: auto;
      }
    }
  }
  /deep/.action-sheet {
  }
}
</style>
